import * as types from './mutation_types'

export default {
  [types.RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: null,
      updated: null,
      violations: null,
      languages: null,
      translation: null,
      translationError: '',
      translationLoading: false
    })
  },

  [types.SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },

  [types.SET_RETRIEVED] (state, retrieved) {
    Object.assign(state, { retrieved })
  },

  [types.SET_UPDATED] (state, updated) {
    Object.assign(state, { error: '', updated, violations: null })
  },

  [types.SET_VIOLATIONS] (state, violations) {
    Object.assign(state, { violations })
  },

  [types.UPDATE_RETRIEVED] (state, updated) {
    Object.assign(state.retrieved, updated)
  },

  [types.UPDATE_TRANSLATION] (state, translation) {
    Object.assign(state, { translation })
  },

  [types.SET_LANGUAGES] (state, languages) {
    Object.assign(state, { languages })
  },

  [types.SET_TRANSLATION] (state, translation) {
    Object.assign(state, { translation })
  },

  [types.TOGGLE_TRANSLATION_LOADING] (state) {
    Object.assign(state, { translationLoading: !state.translationLoading })
  },

  [types.TOGGLE_LANGUAGES_LOADING] (state) {
    Object.assign(state, { languagesLoading: !state.languagesLoading })
  }
}
